export default __webpack_public_path__ + "static/media/noor.ecb5559d.jpg";